import { z } from "zod";
export const BrowserHandoffSchema = z
    .object({
    kind: z.literal("browser_handoff"),
    agentId: z.string().min(1),
    sessionKey: z.string().min(1),
    toolCallId: z.string().min(1),
    confirmationId: z.string().optional(),
    tabId: z.string().min(1),
    instructions: z.string().max(4000),
    origin: z.string(),
    liveUrl: z.string(),
    expiresAt: z.number().finite(),
})
    .strict();
export function parseBrowserHandoff(preview) {
    if (!preview || preview.length > 16000)
        return undefined;
    try {
        const parsed = BrowserHandoffSchema.safeParse(JSON.parse(preview));
        return parsed.success ? parsed.data : undefined;
    }
    catch {
        return undefined;
    }
}
export const BrowserStatusSchema = z.object({
    state: z.enum(["running", "stopped"]),
    enabled: z.boolean(),
    egressMode: z.enum(["denied", "allowlist", "public"]),
    origins: z.array(z.string()),
    handoff: BrowserHandoffSchema.nullable(),
});
export const BrowserViewerMessageSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("state"),
        handoff: BrowserHandoffSchema.nullable(),
        canControl: z.boolean(),
        url: z.string().nullable(),
        width: z.literal(1280),
        height: z.literal(800),
    }),
    z.object({
        type: z.literal("frame"),
        data: z.string().max(4 * 1024 * 1024),
        mimeType: z.literal("image/jpeg"),
    }),
    z.object({ type: z.literal("pointer"), x: z.number(), y: z.number() }),
    z.object({ type: z.literal("notice"), message: z.string().max(1000) }),
]);
